<template>
  <ListTransferStoreForms />
</template>

<script>
import ListTransferStoreForms from '@/view/pages/transfer-store-forms/ListTransferStoreForms.vue';

export default {
  name: 'ProfileTransferStoreForms',
  components: {
    ListTransferStoreForms,
  },
};
</script>
